import { combineReducers } from "redux";

import newFilterReducer from "./NewFilterReducer";

export default combineReducers({
    newFilterReducer,
});